

const PageIntro = ({description}) => {
    return (
        <div className="w-full bg-white dark:bg-gray-800 shadow-lg p-6 rounded-lg border border-gray-200 dark:border-gray-700">
            <p
                className="first-letter:text-5xl first-letter:font-serif first-letter:mr-3 first-letter:float-left 
                    text-gray-800 dark:text-gray-200 leading-relaxed text-lg font-light drop-cap-style columns-3 sm:columns-2 xs:columns-1"
            >
                {description}
            </p>
        </div>
    );
};

export default PageIntro;
